
    import { Component, Vue } from 'vue-property-decorator';

    @Component
    export default class SideBar extends Vue {
        private role: any = [];

        public async mounted() {
            this.role = await this.$store.getters.role;
        }
    }
